import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class meetingSchedulerServices extends ApiBaseService {
    constructor(public http: HttpClient) {
        super(http, '/meeting-scheduler');
    }

}
